import { Module } from "vuex";

import { IRootState } from "@/store";
import { getters } from "@/store/modules/reportTemplate/getters";
import { actions } from "@/store/modules/reportTemplate/actions";
import { mutations } from "@/store/modules/reportTemplate/mutations";
import {
  IReportTemplateState,
  state,
} from "@/store/modules/reportTemplate/state";

export const reportTemplate: Module<IReportTemplateState, IRootState> = {
  actions,
  mutations,
  state,
  getters,
};
